import { render, staticRenderFns } from "./HotpWord.vue?vue&type=template&id=3cc57b2a&scoped=true"
import script from "./HotpWord.vue?vue&type=script&lang=js"
export * from "./HotpWord.vue?vue&type=script&lang=js"
import style0 from "./HotpWord.vue?vue&type=style&index=0&id=3cc57b2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc57b2a",
  null
  
)

export default component.exports